import { Slownik } from '../models/slownik';

export enum StanCywilny {
  KAWALER = 'KAWALER',
  PANNA = 'PANNA',
  ROZWIEDZIONA = 'ROZWIEDZIONA',
  ROZWIEDZIONY = 'ROZWIEDZIONY',
  WDOWA = 'WDOWA',
  WDOWIEC = 'WDOWIEC',
  W_SEPARACJI = 'W SEPARACJI',
  ZAMEZNA = 'ZAMĘŻNA',
  ZONATY = 'ŻONATY',
}

export const STAN_CYWILNY_LABELS: Record<StanCywilny, string> = {
  [StanCywilny.KAWALER]: 'Kawaler',
  [StanCywilny.PANNA]: 'Panna',
  [StanCywilny.ROZWIEDZIONA]: 'Rozwiedziona',
  [StanCywilny.ROZWIEDZIONY]: 'Rozwiedziony',
  [StanCywilny.WDOWA]: 'Wdowa',
  [StanCywilny.WDOWIEC]: 'Wdowiec',
  [StanCywilny.W_SEPARACJI]: 'W separacji',
  [StanCywilny.ZAMEZNA]: 'Zamężna',
  [StanCywilny.ZONATY]: 'Żonaty',
};

export function mezczyznaStanCwyilny(): StanCywilny[] {
  return [
    StanCywilny.KAWALER,
    StanCywilny.ROZWIEDZIONY,
    StanCywilny.WDOWIEC,
    StanCywilny.ZONATY,
    StanCywilny.W_SEPARACJI,
  ];
}

export function kobietaStanCwyilny(): StanCywilny[] {
  return [
    StanCywilny.PANNA,
    StanCywilny.ROZWIEDZIONA,
    StanCywilny.WDOWA,
    StanCywilny.ZAMEZNA,
    StanCywilny.W_SEPARACJI,
  ];
}

export function getMartialStatusDropdownItems() {
  return Object.entries(STAN_CYWILNY_LABELS).map(([key, label]) => ({
    label,
    value: key as StanCywilny,
  }));
}

export function getMartialStatus(): Slownik[] {
  return [
    { id: 10245, kod: '2', nazwa: 'KAWALER', opis: '' },
    { id: 10244, kod: '1', nazwa: 'PANNA', opis: '' },
    { id: 10249, kod: '6', nazwa: 'ROZWIEDZIONA', opis: '' },
    { id: 10248, kod: '5', nazwa: 'ROZWIEDZIONY', opis: '' },
    { id: 10250, kod: '7', nazwa: 'WDOWA', opis: '' },
    { id: 10251, kod: '8', nazwa: 'WDOWIEC', opis: '' },
    { id: 10254, kod: '11', nazwa: 'W SEPARACJI', opis: '' },
    { id: 10247, kod: '4', nazwa: 'ZAMĘŻNA', opis: '' },
    { id: 10246, kod: '3', nazwa: 'ŻONATY', opis: '' },
  ];
}
